import { styled, Typography } from '@mui/material';

export const TicketDrawerLabel = styled(Typography)`
    font-size: 0.9rem;
`;
